// @generated by protoc-gen-connect-es v1.7.0 with parameter "target=ts,import_extension=none"
// @generated from file mono/ryugu/v1/contract_model.proto (package mono.ryugu.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
import { AddGlossaryRelationRequest, AddGlossaryRelationResponse, AddOccurrenceRequest, AddOccurrenceResponse, AddWorkstreamMemberRequest, AddWorkstreamMemberResponse, ApplyEvidenceBatchRequest, ApplyEvidenceBatchResponse, ApproveOccurrenceDecisionRequest, ApproveOccurrenceDecisionResponse, AssessWorkProductsRequest, AssessWorkProductsResponse, BindGlossaryTermRequest, BindGlossaryTermResponse, CreateCommentRequest, CreateCommentResponse, CreateDutyRequest, CreateDutyResponse, CreateScheduleRuleRequest, CreateScheduleRuleResponse, CreateSowRequest, CreateSowResponse, CreateSubmissionRequest, CreateSubmissionResponse, CreateWorkProductRequest, CreateWorkProductResponse, CreateWorkstreamRequest, CreateWorkstreamResponse, DeleteCommentRequest, DeleteCommentResponse, DeleteDutyRequest, DeleteDutyResponse, DeleteSavedViewRequest, DeleteSavedViewResponse, DeleteScheduleRuleRequest, DeleteScheduleRuleResponse, FindWorkProductDuplicatesRequest, FindWorkProductDuplicatesResponse, GetDeliverableSettingsRequest, GetDeliverableSettingsResponse, GetDutyRequest, GetDutyResponse, GetOccurrenceRequest, GetOccurrenceResponse, GetPortfolioDeliverySummaryRequest, GetPortfolioDeliverySummaryResponse, GetProgramGlossaryRequest, GetProgramGlossaryResponse, GetPursuitPipelineRequest, GetPursuitPipelineResponse, GetWorkstreamRequest, GetWorkstreamResponse, ImportTrackerRequest, ImportTrackerResponse, LinkWorkstreamLineageRequest, LinkWorkstreamLineageResponse, ListAttentionItemsRequest, ListAttentionItemsResponse, ListCommentsRequest, ListCommentsResponse, ListDutiesRequest, ListDutiesResponse, ListMyWorkRequest, ListMyWorkResponse, ListOccurrenceDecisionsRequest, ListOccurrenceDecisionsResponse, ListOccurrencesRequest, ListOccurrencesResponse, ListPortfolioOccurrencesRequest, ListPortfolioOccurrencesResponse, ListProgramSubmissionsRequest, ListProgramSubmissionsResponse, ListSavedViewsRequest, ListSavedViewsResponse, ListWorkProductsRequest, ListWorkProductsResponse, ListWorkstreamMembersRequest, ListWorkstreamMembersResponse, ListWorkstreamsRequest, ListWorkstreamsResponse, ListWorkstreamWindowCountsRequest, ListWorkstreamWindowCountsResponse, LogContractEventRequest, LogContractEventResponse, MoveOccurrenceRequest, MoveOccurrenceResponse, PromoteWorkProductRequest, PromoteWorkProductResponse, ProposeExtensionEvidenceRequest, ProposeExtensionEvidenceResponse, ProposeOccurrenceExtensionRequest, ProposeOccurrenceExtensionResponse, ProposeOccurrenceNotOwedRequest, ProposeOccurrenceNotOwedResponse, ProposeOccurrenceWaiverRequest, ProposeOccurrenceWaiverResponse, ProposeSubmissionEditRequest, ProposeSubmissionEditResponse, ProposeSubmissionEvidenceRequest, ProposeSubmissionEvidenceResponse, ProposeWaiverEditRequest, ProposeWaiverEditResponse, ProposeWaiverEvidenceRequest, ProposeWaiverEvidenceResponse, ProposeWaiverRevokeRequest, ProposeWaiverRevokeResponse, RecordOccurrenceDecisionCorAnswerRequest, RecordOccurrenceDecisionCorAnswerResponse, RecordReviewRequest, RecordReviewResponse, RejectGlossaryRelationRequest, RejectGlossaryRelationResponse, RejectGlossaryTermRequest, RejectGlossaryTermResponse, RejectOccurrenceDecisionRequest, RejectOccurrenceDecisionResponse, RekindGlossaryTermRequest, RekindGlossaryTermResponse, RemindOccurrenceRequest, RemindOccurrenceResponse, RemoveOccurrenceRequest, RemoveOccurrenceResponse, RemoveWorkstreamMemberRequest, RemoveWorkstreamMemberResponse, RuleSowGapRequest, RuleSowGapResponse, SaveViewRequest, SaveViewResponse, SetCommentUpvoteRequest, SetCommentUpvoteResponse, SetDutyAssignmentRequest, SetDutyAssignmentResponse, SetExerciseWorkstreamRequest, SetExerciseWorkstreamResponse, UpdateCommentRequest, UpdateCommentResponse, UpdateDeliverableSettingsRequest, UpdateDeliverableSettingsResponse, UpdateDutyRequest, UpdateDutyResponse, UpdateScheduleRuleRequest, UpdateScheduleRuleResponse, UpdateSubmissionRequest, UpdateSubmissionResponse, UpdateWorkProductRequest, UpdateWorkProductResponse, UpdateWorkstreamMemberRequest, UpdateWorkstreamMemberResponse, UpdateWorkstreamRequest, UpdateWorkstreamResponse, WithdrawSubmissionRequest, WithdrawSubmissionResponse } from "./contract_model_pb";
import { MethodKind } from "@bufbuild/protobuf";
/**
 * ContractModelService is the browser door onto contract model v2's verbs
 * (plan S3b). ryugu authorizes every call and forwards its body, with the
 * signed-in user (connectutil.ForwardPrincipal), to pangaea's
 * ContractModelGatewayService, which owns the rows and the rules. Each
 * message wraps pangaea's own as `body`: those carry no tenant or actor
 * (R8), so the browser sends them as they are.
 *
 * Authorization (D111):
 *   - reads: the program read projection;
 *   - writes: the `execution` write area on the program (area:execution);
 *   - RecordReview: area:execution.verdict, recording the government's
 *     verdict, granted apart from doing the work;
 *   - RuleSowGap: change_set:commit (D94), on a program the caller can see;
 *   - UpdateDeliverableSettings: area:programs;
 *   - waiving a date or marking one not owed: dual control. The direct
 *     verbs are not on this service; one user proposes, a different user
 *     approves (ApproveOccurrenceDecision applies it), and
 *     RejectOccurrenceDecision ends a proposal (withdrawn by its proposer,
 *     rejected by anyone else; D112).
 *
 * @generated from service mono.ryugu.v1.ContractModelService
 */ export const ContractModelService = {
    typeName: "mono.ryugu.v1.ContractModelService",
    methods: {
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.CreateDuty
     */ createDuty: {
            name: "CreateDuty",
            I: CreateDutyRequest,
            O: CreateDutyResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.UpdateDuty
     */ updateDuty: {
            name: "UpdateDuty",
            I: UpdateDutyRequest,
            O: UpdateDutyResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.DeleteDuty
     */ deleteDuty: {
            name: "DeleteDuty",
            I: DeleteDutyRequest,
            O: DeleteDutyResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.GetDuty
     */ getDuty: {
            name: "GetDuty",
            I: GetDutyRequest,
            O: GetDutyResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.ListDuties
     */ listDuties: {
            name: "ListDuties",
            I: ListDutiesRequest,
            O: ListDutiesResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.CreateScheduleRule
     */ createScheduleRule: {
            name: "CreateScheduleRule",
            I: CreateScheduleRuleRequest,
            O: CreateScheduleRuleResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.UpdateScheduleRule
     */ updateScheduleRule: {
            name: "UpdateScheduleRule",
            I: UpdateScheduleRuleRequest,
            O: UpdateScheduleRuleResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.DeleteScheduleRule
     */ deleteScheduleRule: {
            name: "DeleteScheduleRule",
            I: DeleteScheduleRuleRequest,
            O: DeleteScheduleRuleResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.AddOccurrence
     */ addOccurrence: {
            name: "AddOccurrence",
            I: AddOccurrenceRequest,
            O: AddOccurrenceResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.RemoveOccurrence
     */ removeOccurrence: {
            name: "RemoveOccurrence",
            I: RemoveOccurrenceRequest,
            O: RemoveOccurrenceResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.MoveOccurrence
     */ moveOccurrence: {
            name: "MoveOccurrence",
            I: MoveOccurrenceRequest,
            O: MoveOccurrenceResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.ProposeOccurrenceWaiver
     */ proposeOccurrenceWaiver: {
            name: "ProposeOccurrenceWaiver",
            I: ProposeOccurrenceWaiverRequest,
            O: ProposeOccurrenceWaiverResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.ProposeOccurrenceNotOwed
     */ proposeOccurrenceNotOwed: {
            name: "ProposeOccurrenceNotOwed",
            I: ProposeOccurrenceNotOwedRequest,
            O: ProposeOccurrenceNotOwedResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.ProposeOccurrenceExtension
     */ proposeOccurrenceExtension: {
            name: "ProposeOccurrenceExtension",
            I: ProposeOccurrenceExtensionRequest,
            O: ProposeOccurrenceExtensionResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.ProposeSubmissionEdit
     */ proposeSubmissionEdit: {
            name: "ProposeSubmissionEdit",
            I: ProposeSubmissionEditRequest,
            O: ProposeSubmissionEditResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.ProposeSubmissionEvidence
     */ proposeSubmissionEvidence: {
            name: "ProposeSubmissionEvidence",
            I: ProposeSubmissionEvidenceRequest,
            O: ProposeSubmissionEvidenceResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.ProposeWaiverEvidence
     */ proposeWaiverEvidence: {
            name: "ProposeWaiverEvidence",
            I: ProposeWaiverEvidenceRequest,
            O: ProposeWaiverEvidenceResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.ProposeExtensionEvidence
     */ proposeExtensionEvidence: {
            name: "ProposeExtensionEvidence",
            I: ProposeExtensionEvidenceRequest,
            O: ProposeExtensionEvidenceResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.ProposeWaiverEdit
     */ proposeWaiverEdit: {
            name: "ProposeWaiverEdit",
            I: ProposeWaiverEditRequest,
            O: ProposeWaiverEditResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.ProposeWaiverRevoke
     */ proposeWaiverRevoke: {
            name: "ProposeWaiverRevoke",
            I: ProposeWaiverRevokeRequest,
            O: ProposeWaiverRevokeResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.RecordOccurrenceDecisionCorAnswer
     */ recordOccurrenceDecisionCorAnswer: {
            name: "RecordOccurrenceDecisionCorAnswer",
            I: RecordOccurrenceDecisionCorAnswerRequest,
            O: RecordOccurrenceDecisionCorAnswerResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.ApproveOccurrenceDecision
     */ approveOccurrenceDecision: {
            name: "ApproveOccurrenceDecision",
            I: ApproveOccurrenceDecisionRequest,
            O: ApproveOccurrenceDecisionResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.RejectOccurrenceDecision
     */ rejectOccurrenceDecision: {
            name: "RejectOccurrenceDecision",
            I: RejectOccurrenceDecisionRequest,
            O: RejectOccurrenceDecisionResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.ListOccurrenceDecisions
     */ listOccurrenceDecisions: {
            name: "ListOccurrenceDecisions",
            I: ListOccurrenceDecisionsRequest,
            O: ListOccurrenceDecisionsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.GetOccurrence
     */ getOccurrence: {
            name: "GetOccurrence",
            I: GetOccurrenceRequest,
            O: GetOccurrenceResponse,
            kind: MethodKind.Unary
        },
        /**
     * ListProgramSubmissions is a program read: the same gate and masking as
     * GetOccurrence (ContractModelReadProcedures).
     *
     * @generated from rpc mono.ryugu.v1.ContractModelService.ListProgramSubmissions
     */ listProgramSubmissions: {
            name: "ListProgramSubmissions",
            I: ListProgramSubmissionsRequest,
            O: ListProgramSubmissionsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.ListOccurrences
     */ listOccurrences: {
            name: "ListOccurrences",
            I: ListOccurrencesRequest,
            O: ListOccurrencesResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.ListWorkstreamWindowCounts
     */ listWorkstreamWindowCounts: {
            name: "ListWorkstreamWindowCounts",
            I: ListWorkstreamWindowCountsRequest,
            O: ListWorkstreamWindowCountsResponse,
            kind: MethodKind.Unary
        },
        /**
     * GetPortfolioDeliverySummary (SAD-999) reads only the programs the
     * viewer can see: ryugu lists the tenant's programs in the portfolio and
     * sector asked for, keeps those the program read resolves to a view, and
     * forwards body.program_ids as that set (narrowed to the ones asked for).
     *
     * @generated from rpc mono.ryugu.v1.ContractModelService.GetPortfolioDeliverySummary
     */ getPortfolioDeliverySummary: {
            name: "GetPortfolioDeliverySummary",
            I: GetPortfolioDeliverySummaryRequest,
            O: GetPortfolioDeliverySummaryResponse,
            kind: MethodKind.Unary
        },
        /**
     * ListPortfolioOccurrences (SAD-1000) is scoped the same way: only the
     * programs the viewer can see are forwarded in body.filter.program_ids.
     *
     * @generated from rpc mono.ryugu.v1.ContractModelService.ListPortfolioOccurrences
     */ listPortfolioOccurrences: {
            name: "ListPortfolioOccurrences",
            I: ListPortfolioOccurrencesRequest,
            O: ListPortfolioOccurrencesResponse,
            kind: MethodKind.Unary
        },
        /**
     * ListAttentionItems (SAD-1000) is scoped the same way.
     *
     * @generated from rpc mono.ryugu.v1.ContractModelService.ListAttentionItems
     */ listAttentionItems: {
            name: "ListAttentionItems",
            I: ListAttentionItemsRequest,
            O: ListAttentionItemsResponse,
            kind: MethodKind.Unary
        },
        /**
     * ListMyWork (SAD-1005) is the Dashboard's Waiting on You in one read:
     * everything that is the caller's across delivery, pursuits and shared
     * items, each source authorized as its own page authorizes it, ranked by
     * one rule, with every kind's count and the next 5 working days.
     *
     * @generated from rpc mono.ryugu.v1.ContractModelService.ListMyWork
     */ listMyWork: {
            name: "ListMyWork",
            I: ListMyWorkRequest,
            O: ListMyWorkResponse,
            kind: MethodKind.Unary
        },
        /**
     * GetPursuitPipeline (SAD-1005) is the Dashboard's Pursuits by stage and
     * its Decisions due tile, across the pursuits the caller can see (the
     * capture_project:list grant, then each pursuit's read, in one resolve).
     *
     * @generated from rpc mono.ryugu.v1.ContractModelService.GetPursuitPipeline
     */ getPursuitPipeline: {
            name: "GetPursuitPipeline",
            I: GetPursuitPipelineRequest,
            O: GetPursuitPipelineResponse,
            kind: MethodKind.Unary
        },
        /**
     * Saved views (SAD-1000): the caller's own and its tenant's shared views,
     * scoped by the principal in pangaea (no program is named).
     *
     * @generated from rpc mono.ryugu.v1.ContractModelService.ListSavedViews
     */ listSavedViews: {
            name: "ListSavedViews",
            I: ListSavedViewsRequest,
            O: ListSavedViewsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.SaveView
     */ saveView: {
            name: "SaveView",
            I: SaveViewRequest,
            O: SaveViewResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.DeleteSavedView
     */ deleteSavedView: {
            name: "DeleteSavedView",
            I: DeleteSavedViewRequest,
            O: DeleteSavedViewResponse,
            kind: MethodKind.Unary
        },
        /**
     * RemindOccurrence (SAD-1000) is a program write, gated like the date's
     * other writes.
     *
     * @generated from rpc mono.ryugu.v1.ContractModelService.RemindOccurrence
     */ remindOccurrence: {
            name: "RemindOccurrence",
            I: RemindOccurrenceRequest,
            O: RemindOccurrenceResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.LogContractEvent
     */ logContractEvent: {
            name: "LogContractEvent",
            I: LogContractEventRequest,
            O: LogContractEventResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.CreateWorkstream
     */ createWorkstream: {
            name: "CreateWorkstream",
            I: CreateWorkstreamRequest,
            O: CreateWorkstreamResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.UpdateWorkstream
     */ updateWorkstream: {
            name: "UpdateWorkstream",
            I: UpdateWorkstreamRequest,
            O: UpdateWorkstreamResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.GetWorkstream
     */ getWorkstream: {
            name: "GetWorkstream",
            I: GetWorkstreamRequest,
            O: GetWorkstreamResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.ListWorkstreams
     */ listWorkstreams: {
            name: "ListWorkstreams",
            I: ListWorkstreamsRequest,
            O: ListWorkstreamsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.LinkWorkstreamLineage
     */ linkWorkstreamLineage: {
            name: "LinkWorkstreamLineage",
            I: LinkWorkstreamLineageRequest,
            O: LinkWorkstreamLineageResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.CreateSow
     */ createSow: {
            name: "CreateSow",
            I: CreateSowRequest,
            O: CreateSowResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.SetExerciseWorkstream
     */ setExerciseWorkstream: {
            name: "SetExerciseWorkstream",
            I: SetExerciseWorkstreamRequest,
            O: SetExerciseWorkstreamResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.SetDutyAssignment
     */ setDutyAssignment: {
            name: "SetDutyAssignment",
            I: SetDutyAssignmentRequest,
            O: SetDutyAssignmentResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.RuleSowGap
     */ ruleSowGap: {
            name: "RuleSowGap",
            I: RuleSowGapRequest,
            O: RuleSowGapResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.CreateSubmission
     */ createSubmission: {
            name: "CreateSubmission",
            I: CreateSubmissionRequest,
            O: CreateSubmissionResponse,
            kind: MethodKind.Unary
        },
        /**
     * UpdateSubmission is closed on pangaea (SAD-902 dual control); kept here so
     * the browser door matches the gateway surface. Prefer ProposeSubmissionEdit
     * / ProposeSubmissionEvidence.
     *
     * @generated from rpc mono.ryugu.v1.ContractModelService.UpdateSubmission
     */ updateSubmission: {
            name: "UpdateSubmission",
            I: UpdateSubmissionRequest,
            O: UpdateSubmissionResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.WithdrawSubmission
     */ withdrawSubmission: {
            name: "WithdrawSubmission",
            I: WithdrawSubmissionRequest,
            O: WithdrawSubmissionResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.RecordReview
     */ recordReview: {
            name: "RecordReview",
            I: RecordReviewRequest,
            O: RecordReviewResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.ApplyEvidenceBatch
     */ applyEvidenceBatch: {
            name: "ApplyEvidenceBatch",
            I: ApplyEvidenceBatchRequest,
            O: ApplyEvidenceBatchResponse,
            kind: MethodKind.Unary
        },
        /**
     * Deprecated: the old name of ApplyEvidenceBatch, kept in proto only. No
     * handler implements it; it answers Unimplemented.
     *
     * @generated from rpc mono.ryugu.v1.ContractModelService.ImportTracker
     * @deprecated
     */ importTracker: {
            name: "ImportTracker",
            I: ImportTrackerRequest,
            O: ImportTrackerResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.GetDeliverableSettings
     */ getDeliverableSettings: {
            name: "GetDeliverableSettings",
            I: GetDeliverableSettingsRequest,
            O: GetDeliverableSettingsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.UpdateDeliverableSettings
     */ updateDeliverableSettings: {
            name: "UpdateDeliverableSettings",
            I: UpdateDeliverableSettingsRequest,
            O: UpdateDeliverableSettingsResponse,
            kind: MethodKind.Unary
        },
        /**
     * Program glossary reviewer surface (SAD-716 S5b-2 B). Upsert stays on
     * pangaea (reverie). Edits require change_set:commit (D94/D111).
     *
     * @generated from rpc mono.ryugu.v1.ContractModelService.GetProgramGlossary
     */ getProgramGlossary: {
            name: "GetProgramGlossary",
            I: GetProgramGlossaryRequest,
            O: GetProgramGlossaryResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.RekindGlossaryTerm
     */ rekindGlossaryTerm: {
            name: "RekindGlossaryTerm",
            I: RekindGlossaryTermRequest,
            O: RekindGlossaryTermResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.RejectGlossaryTerm
     */ rejectGlossaryTerm: {
            name: "RejectGlossaryTerm",
            I: RejectGlossaryTermRequest,
            O: RejectGlossaryTermResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.RejectGlossaryRelation
     */ rejectGlossaryRelation: {
            name: "RejectGlossaryRelation",
            I: RejectGlossaryRelationRequest,
            O: RejectGlossaryRelationResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.AddGlossaryRelation
     */ addGlossaryRelation: {
            name: "AddGlossaryRelation",
            I: AddGlossaryRelationRequest,
            O: AddGlossaryRelationResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.BindGlossaryTerm
     */ bindGlossaryTerm: {
            name: "BindGlossaryTerm",
            I: BindGlossaryTermRequest,
            O: BindGlossaryTermResponse,
            kind: MethodKind.Unary
        },
        /**
     * SAD-859 team membership and the work-product ledger. Members are managed
     * with area:execution. A work product is created or edited by a member of
     * its team or by anyone with area:execution on the program (checked in the
     * handler); assessing and promoting need area:execution.
     *
     * @generated from rpc mono.ryugu.v1.ContractModelService.ListWorkstreamMembers
     */ listWorkstreamMembers: {
            name: "ListWorkstreamMembers",
            I: ListWorkstreamMembersRequest,
            O: ListWorkstreamMembersResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.AddWorkstreamMember
     */ addWorkstreamMember: {
            name: "AddWorkstreamMember",
            I: AddWorkstreamMemberRequest,
            O: AddWorkstreamMemberResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.UpdateWorkstreamMember
     */ updateWorkstreamMember: {
            name: "UpdateWorkstreamMember",
            I: UpdateWorkstreamMemberRequest,
            O: UpdateWorkstreamMemberResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.RemoveWorkstreamMember
     */ removeWorkstreamMember: {
            name: "RemoveWorkstreamMember",
            I: RemoveWorkstreamMemberRequest,
            O: RemoveWorkstreamMemberResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.CreateWorkProduct
     */ createWorkProduct: {
            name: "CreateWorkProduct",
            I: CreateWorkProductRequest,
            O: CreateWorkProductResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.UpdateWorkProduct
     */ updateWorkProduct: {
            name: "UpdateWorkProduct",
            I: UpdateWorkProductRequest,
            O: UpdateWorkProductResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.ListWorkProducts
     */ listWorkProducts: {
            name: "ListWorkProducts",
            I: ListWorkProductsRequest,
            O: ListWorkProductsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.AssessWorkProducts
     */ assessWorkProducts: {
            name: "AssessWorkProducts",
            I: AssessWorkProductsRequest,
            O: AssessWorkProductsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.PromoteWorkProduct
     */ promoteWorkProduct: {
            name: "PromoteWorkProduct",
            I: PromoteWorkProductRequest,
            O: PromoteWorkProductResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.FindWorkProductDuplicates
     */ findWorkProductDuplicates: {
            name: "FindWorkProductDuplicates",
            I: FindWorkProductDuplicatesRequest,
            O: FindWorkProductDuplicatesResponse,
            kind: MethodKind.Unary
        },
        /**
     * SAD-863 comment threads on deliverables, dates and work products.
     * Anyone who can read the program may read and comment; only the author
     * edits or deletes a comment (pangaea checks, against the signed-in user).
     *
     * @generated from rpc mono.ryugu.v1.ContractModelService.ListComments
     */ listComments: {
            name: "ListComments",
            I: ListCommentsRequest,
            O: ListCommentsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.CreateComment
     */ createComment: {
            name: "CreateComment",
            I: CreateCommentRequest,
            O: CreateCommentResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.UpdateComment
     */ updateComment: {
            name: "UpdateComment",
            I: UpdateCommentRequest,
            O: UpdateCommentResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.DeleteComment
     */ deleteComment: {
            name: "DeleteComment",
            I: DeleteCommentRequest,
            O: DeleteCommentResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.SetCommentUpvote
     */ setCommentUpvote: {
            name: "SetCommentUpvote",
            I: SetCommentUpvoteRequest,
            O: SetCommentUpvoteResponse,
            kind: MethodKind.Unary
        }
    }
};
